module.exports = __webpack_public_path__ + "static/media/change2.82472b26.svg";